import { CommonModule, NgIf, isPlatformServer } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnInit, PLATFORM_ID, ViewChild, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { DynamicComponent, DynamicIoDirective } from 'ng-dynamic-component';
import { sleep } from 'src/app/lib/sleep';
import { PictureComponent } from 'src/app/shared/components/picture/picture.component';
import { AnimateWhenInViewDirective } from 'src/app/shared/directives/animate-when-in-view.directive';
import { ComponentValues, Components } from '../../components';
import { ReplaceTextPipe } from '../../pipes/replace-text.pipe';
import { StoryblokCdnPipe } from '../../pipes/storyblok-cdn.pipe';
import { StoryblokRichTextPipe } from '../../storyblok-rich-text.pipe';
import { StoryblokCta, StoryblokImage } from '../../storyblok-types';
import { StoryblokDirective } from '../../storyblok.directive';
import { BlockStyle, BlockWrapperComponent, getPageWidth } from '../block-wrapper/block-wrapper.component';

@Component({
  selector: 'app-teaser',
  standalone: true,
  templateUrl: './teaser.component.html',
  styleUrls: ['./teaser.component.scss'],
  imports: [
    CommonModule,
    PictureComponent,
    AnimateWhenInViewDirective,
    RouterLink,
    StoryblokDirective,
    StoryblokRichTextPipe,
    DynamicComponent,
    DynamicIoDirective,
    BlockWrapperComponent,
    NgIf,
    StoryblokCdnPipe,
    ReplaceTextPipe,
  ],
})
export class TeaserComponent implements OnChanges, OnInit {
  @ViewChild('videoEl') videoEl: ElementRef<HTMLVideoElement>;
  @Input() _uid: string; // just here to prevent errors
  @Input() component: string; // just here to prevent errors
  @Input() _editable: string;
  @Input() replacer?: (key: string) => string;
  @Input() style: BlockStyle[];

  @Input() assetOutOfFrame: boolean;
  // @Input() image: any;
  @Input() asset: {
    image: StoryblokImage;
    poster?: StoryblokImage;
    _editable: string;
    video?: StoryblokImage;
  };

  @Input() assetBackground: StoryblokImage;
  @Input() content: InstanceType<ComponentValues>[];
  @Input() assetPosition: 'left' | 'right' = 'right';
  @Input() shadowBox: boolean;
  @Input() hideAssetOnMobile: boolean;

  maxWidth: number;

  components = Components;
  private platformId = inject(PLATFORM_ID);

  dimensions: {
    width: number;
    height: number;
  } = {
    width: 1000,
    height: 1000,
  };

  cta: StoryblokCta;

  private getImageUrl() {
    if (!this.asset) return;
    if (this.asset.video) {
      return this.asset.poster?.filename;
    }
    return this.asset.image?.filename;
  }

  async ngOnInit() {
    if (!this.asset?.video) return;
    if (isPlatformServer(this.platformId)) return;
    await sleep(0);
    if (!this.videoEl) return;
    this.videoEl.nativeElement.muted = true;
    this.videoEl.nativeElement.autoplay = true;
  }

  ngOnChanges(): void {
    this.maxWidth = getPageWidth(this.style?.[0]?.pageWidth, this.style?.[0]?.customPageWidth);
    if (Array.isArray(this.asset)) {
      this.asset = this.asset[0];
    }
    this.content.forEach(item => {
      if (!('style' in item)) return;
      if (!item.style) return;
      if (Array.isArray(item.style) && !item.style.length) {
        item.style = [{} as BlockStyle];
      }
      item.style[0].inWrapper = true;
    });

    const url = this.getImageUrl();
    if (!url) return;

    this.dimensions = {
      width: parseInt(url.split('/')[5]?.split('x')[0]),
      height: parseInt(url.split('/')[5]?.split('x')[1]),
    };
  }

  trackByFunction(index: number, item: InstanceType<ComponentValues>) {
    return item._uid;
  }

  dynamicInputs(values: { [key: string]: unknown }) {
    const data = { ...values, replacer: this.replacer };
    return data;
  }
}
